






































































import mixins from '@/utils/mixins';
import Proxyable from '@/mixins/proxyable';

//models
import { Question, SubRule } from '@/models/configurator/question';
import { Module } from '@/models/configurator/module';

//helpers
import { mapActions } from 'vuex';
import { get } from 'vuex-pathify';
import { isNil } from 'lodash';

export default mixins(Proxyable).extend({
  name: 'ConfiguratorRuleCard',

  props: {
    noChoice: Boolean
  },

  computed: {
    modules: get<Module[]>('configuratorModule/modules'),
    questions: get<Module[]>('configuratorQuestion/questions'),

    getQuestionById: get<(module: number, id: number) => Question>(
      'configuratorQuestion/getQuestionById'
    )
  },

  methods: {
    isNil,
    ...mapActions('configuratorQuestion', ['fetchQuestions']),

    removeRule() {
      this.$emit('removeRule');
    },

    finishAnswering(rule: SubRule) {
      this.$emit('finishAnswering', rule);
    },

    removeChoice() {
      this.$emit('removeChoice', this.internalValue);
    }
  }
});
